import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { BottomNav } from "@/components/BottomNav";
import { AuthModal } from "@/components/AuthModal";
import { WalletSheet } from "@/components/wallet/WalletSheet";

export const Layout = () => (
  <div className="min-h-screen pb-24">
    <Header />
    <main className="max-w-6xl mx-auto px-3 sm:px-4 py-5">
      <Outlet />
    </main>
    <BottomNav />
    <AuthModal />
    <WalletSheet />
  </div>
);
